
import React from 'react';
import ShopifyModal from "../../../../components/ShopifyModal";
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import utils from '../../../../utils/utils'
const BlackRaffleRuleModal = ({open,handleOff})=> {
    const router = useHistory()
    return (
        <div>
        <ShopifyModal id="black-not-points-modal"
            size='middle'
            open={open}
            heading="Insufficient Points"
            primaryAction={{
                content: 'Earn Points', onAction: () => {
                    // utils.routeListen('/admin/points')
                    utils.routeJump1(router,'/admin/points')
                }
            }}
            secondaryActions={{
                content: 'Cancel', onAction: () => handleOff()
            }}
            onClose={() => handleOff()}>
                <p>You don't have enough points to enter the raffle. Please earn more points to continue.</p>
            </ShopifyModal>
        </div>
    );
}

export default BlackRaffleRuleModal;
